import { render } from "./TraqrTableElement.vue?vue&type=template&id=217d461e"
import script from "./TraqrTableElement.vue?vue&type=script&lang=js"
export * from "./TraqrTableElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__